

























import { Component, Vue, Prop } from 'nuxt-property-decorator'
import Parallaxy from 'vue-parallaxy'

@Component({
  name: 'Parallax',
  components: {
    Parallaxy
  }
})
export default class extends Vue {
  @Prop() src
  @Prop({ default: 400 }) height
  @Prop({ default: false }) contain
  @Prop() overlay
}
